import { useMemo, useState } from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import OverallStatus from './overallstatus';
import Package from '../../package.json';

const ITEMS_PER_PAGE = 10;

function App() {
  const [currentPage, setCurrentPage] = useState(1);

  const apikeys = useMemo(() => {
    const { ApiKeys } = window.Config;
    let keys = [];
    if (Array.isArray(ApiKeys)) keys = ApiKeys;
    else if (typeof ApiKeys === 'string') keys = [ApiKeys];
    // Normalize each entry to an object with key, name, link
    return keys.map((item) => {
      if (typeof item === 'string') {
        return { key: item };
      }
      return item;
    });
  }, []);

  const totalPages = Math.ceil(apikeys.length / ITEMS_PER_PAGE);
  const showPagination = apikeys.length > ITEMS_PER_PAGE;

  const paginatedKeys = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return apikeys.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  }, [apikeys, currentPage]);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <>
      <Header />
      <div className='container'>
        <div id='uptime'>
          {paginatedKeys.map((config) => (
            <UptimeRobot key={config.key} apiConfig={config} />
          ))}
          {showPagination && (
            <div className='pagination'>
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className='pagination-btn'
              >
                ← Prev
              </button>
              <span className='pagination-info'>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className='pagination-btn'
              >
                Next →
              </button>
            </div>
          )}
        </div>
        <OverallStatus apiConfigs={apikeys} />
        <div id='footer'>
          <p>Powered by <Link to='https://uptimerobot.com/' text='UptimeRobot' /> API</p>
          <p>&copy; 2026 <Link to='https://status.noobzhax.com/' text='Hax Projects' />, Version {Package.version}</p>
        </div>
      </div>
    </>
  );
}

export default App;
